<mat-progress-bar class="progress-margin" color="primary" *ngIf="loading || loadingCalendar" mode="indeterminate">
</mat-progress-bar>
<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <form [formGroup]="reservationCalendarFormGroup">
            <div class="calendar-box">

                <mat-form-field *ngIf="canChangeSessions">
                    <mat-label>Sessiones</mat-label>
                    <mat-select formControlName="Session">
                        <mat-option *ngFor="let session of sessions" [value]="session">
                            {{ session }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="margin-right-xs">
                    <input type="text" matInput placeholder="Profesional" formControlName="Doctor" (input)="onDoctorChange()" [matAutocomplete]="autDoctor">
                    <mat-autocomplete #autDoctor="matAutocomplete" (optionSelected)="onDoctorSelected($event.option.value)">
                        <mat-option *ngFor="let physician of orderedPhysician" [value]="physician">
                            {{physician}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field *ngIf="!ocultarEquipment" class="margin-right-xs">
                    <input type="text" matInput placeholder="Equipo" formControlName="Equipment" (input)="onEquipmentChange()" [matAutocomplete]="autEquipment">
                    <mat-autocomplete #autEquipment="matAutocomplete" (optionSelected)="onEquipmentSelected($event.option.value)">
                        <mat-option *ngFor="let equipment of equipments" [value]="equipment">
                            {{equipment}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field class="full-width margin-right-small">
                    <mat-select placeholder="Centro" formControlName="Center" multiple>
                        <mat-select-trigger>
                            {{selectedCenters?.length > 0 ?selectedCenters[0] : ''}}
                            <span *ngIf="selectedCenters?.length > 1" class="additional-selection">
                                (+{{selectedCenters.length - 1}} {{selectedCenters?.length === 2 ? 'otro' : 'otros'}})
                              </span>
                        </mat-select-trigger>
                        <mat-option (onSelectionChange)="onCenterSelectionChange($event)" *ngFor="let center of centers" [value]="center">
                            {{center}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <p-calendar [disabled]="loading" [locale]="es" (onMonthChange)="onMonthChange($event)" formControlName="Calendar" [numberOfMonths]="2" [inline]="true">
                    <ng-template pTemplate="date" let-date>
                        <span [ngStyle]="{'backgroundColor': getDateColor(date)}" style="border-radius:50%">{{date.day}}</span>
                    </ng-template>
                </p-calendar>

                <button *ngIf="canCreatePendingReservation" [disabled]="creatingPendingReservation" (click)="createPendingReservation()" color="primary" mat-flat-button type="button">GUARDAR TURNO EN ESPERA</button>

            </div>
            <div class="slot-box margin-left-medium">

                <div class="card-inline">
                    <h4><span [matBadge]="selectedSlot" matBadgeColor="accent" matBadgeOverlap="false">Turnos</span></h4>
                </div>
                <div class="card-inline margin-left-large">
                    <mat-checkbox formControlName="ManualSelection">Selección manual</mat-checkbox>
                </div>
                <div *ngIf="seeDraft && !ocultarVerBorrador" class="card-inline margin-left-large">
                    <mat-checkbox (change)="seeDraftChange()" formControlName="SeeDraft">Ver borrador</mat-checkbox>
                </div>
                <div class="card-inline margin-left-large">
                    <mat-checkbox (change)="seeBusyChange()" formControlName="SeeBusy">Ver ocupados</mat-checkbox>
                </div>

                <div *ngIf="seeNoRulesRestriction" class="card-inline margin-left-large">
                    <mat-checkbox (change)="seeNoRulesChange()" formControlName="SeeNoRulesRestriction">No reglas restricción</mat-checkbox>
                </div>

                <div *ngIf="seeNoRules" class="card-inline margin-left-large">
                    <mat-checkbox (change)="seeNoRulesChange()" formControlName="SeeNoRules">No reglas</mat-checkbox>
                </div>


                <div class="card-inline margin-left-large">
                    <mat-spinner *ngIf="searchPatientReservations" [diameter]="20"></mat-spinner>
                    <button *ngIf="!searchPatientReservations" (click)="showPatientReservationSearchItems()" mat-icon-button>
                        <mat-icon>search</mat-icon><span>Otros turnos</span>
                    </button>
                </div>


                <div *ngIf="showReservationEquipmentAvailability">
                    <mat-spinner [diameter]="50" *ngIf="equipmentsAvailabilitySearching">
                    </mat-spinner>
                    <mat-form-field *ngIf="!equipmentsAvailabilitySearching" class="margin-right-xs">
                        <input type="text" matInput placeholder="Consultorio" formControlName="EquipmentAvailability" [matAutocomplete]="autEquipmentAvailability">
                        <mat-autocomplete #autEquipmentAvailability="matAutocomplete" [displayWith]="equipmentAvailabilityDisplayFn" (optionSelected)="onEquipmentAvailabilitySelected($event.option.value)">
                            <mat-option *ngFor="let equipment of equipmentsAvailability" [value]="equipment">
                                {{equipment.Name}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <div class="card-inline margin-left-large">
                    <h5 style="color:red">{{ validationSlotMessage() }}</h5>
                </div>


                <mat-divider></mat-divider>
                <mat-spinner *ngIf="loading"></mat-spinner>
                <div *ngIf="!loading" class="slot-table-container margin-top-xx margin-left-xs">
                    <table mat-table class="slot-table" [dataSource]="slotsDataSource">
                        <tr mat-header-row class="table-header" *matHeaderRowDef="slotsColumns; sticky: true"></tr>
                        <tr mat-row class="table-cell cursor-default" *matRowDef="let row; let i = index; columns: slotsColumns;" (click)="slotSelected(row)"></tr>
                        <ng-container class="table-cell cursor-default" matColumnDef="From">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Desde </th>
                            <td mat-cell [style.backgroundColor]="element.ServiceColor" class="table-cell cursor-default" *matCellDef="let element"> {{element.From}} </td>
                        </ng-container>
                        <ng-container class="table-cell cursor-default" matColumnDef="To">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Hasta </th>
                            <td mat-cell [style.backgroundColor]="element.IsSelected? element.ServiceColor : ''" class="table-cell cursor-default" *matCellDef="let element"> {{element.To}} </td>
                        </ng-container>
                        <ng-container class="table-cell cursor-default" matColumnDef="Doctor">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Profesional </th>
                            <td mat-cell [style.backgroundColor]="element.IsSelected? element.ServiceColor : ''" class="table-cell cursor-default" *matCellDef="let element"> {{element.PhysicianFullName}} </td>
                        </ng-container>
                        <ng-container class="table-cell cursor-default" matColumnDef="PracticeRegionName">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Práctica </th>
                            <td mat-cell [style.backgroundColor]="element.IsSelected? element.ServiceColor : ''" class="table-cell cursor-default" *matCellDef="let element"> {{element.PracticeRegionName}} </td>
                        </ng-container>
                        <ng-container *ngIf="!ocultarEquipment" class="table-cell cursor-default" matColumnDef="EquipmentName">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Equipo </th>
                            <td mat-cell [style.backgroundColor]="element.IsSelected? element.ServiceColor : ''" class="table-cell cursor-default" *matCellDef="let element"> {{element.EquipmentName}} </td>
                        </ng-container>
                        <ng-container *ngIf="ocultarEquipment" style="width: 0px;" matColumnDef="EquipmentName">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let element"> </td>
                        </ng-container>
                        <ng-container class="table-cell cursor-default" matColumnDef="Patient">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Paciente </th>
                            <td mat-cell [style.backgroundColor]="element.IsSelected? element.ServiceColor : ''" class="table-cell cursor-default" *matCellDef="let element"> {{element.Patient}} </td>
                        </ng-container>
                    </table>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="!loading" class="clearfix">
        <div class="pull-right margin-right-medium margin-top-medium">
            <button class="card-inline" type="button" (click)="reservationWizardService.cancel()" mat-button>CANCELAR</button>
        </div>
        <div class="card-footer margin-top-medium">
            <button mat-button color="primary" matStepperPrevious>ANTERIOR</button>
            <button color="primary" mat-flat-button matStepperNext type="submit">SIGUIENTE</button>
        </div>
    </div>
</div>
